import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, DownloadIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
export function FinalCTA() {
  return <section className="py-32 relative overflow-hidden border-t border-white/5" data-id="element-135">
      {/* Cinematic Lighting */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl h-[700px] bg-gold-radial opacity-40 pointer-events-none blur-3xl" data-id="element-136" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-137">
        {/* Books Composition - Real Combo Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex justify-center mb-16 relative" data-id="element-138">
          <img src="https://cdn.magicpatterns.com/uploads/wnMN36qjpDCiyuYpc9wCAV/ChatGPT_Image_May_26,_2026_at_01_54_26_PM.png" alt="The complete 500 AI Prompts system with all 3 bonuses" className="w-full max-w-3xl mx-auto rounded-2xl shadow-[0_30px_80px_rgba(201,169,97,0.2)]" data-id="element-139" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite leading-[1.05] mb-6 tracking-tight" data-id="element-140">
          Stop figuring it out. <br className="hidden md:block" data-id="element-141" />
          <span className="text-gold" data-id="element-142">Start shipping.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-muted max-w-2xl mx-auto mb-12" data-id="element-143">
          Stop wasting hours trying to figure out what to ask AI. Get instant
          access to 500 professionally designed prompts ready to copy, paste and
          adapt.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="max-w-md mx-auto bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-glass mb-8" data-id="element-144">
          <div className="flex justify-center items-baseline gap-3 mb-2" data-id="element-145">
            <span className="text-muted line-through text-lg" data-id="element-146">$147</span>
            <span className="font-display font-black text-6xl text-gold tracking-tight" data-id="element-147">
              $27 <span className="text-2xl" data-id="element-148">USD</span>
            </span>
          </div>
          <p className="text-xs text-muted mb-8 uppercase tracking-widest font-semibold" data-id="element-149">
            One-time payment · Digital download
          </p>

          <BuyButton label="Yes, I Want My 500 Prompts" className="w-full py-5 bg-gold text-black font-bold text-lg rounded-xl hover:bg-gold-light transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 uppercase tracking-wide" data-id="element-150" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center gap-8" data-id="element-151">
          {/* Strong Guarantee Badge */}
          <div className="flex items-center gap-4 bg-white/5 border border-gold/20 px-6 py-4 rounded-xl max-w-md" data-id="element-152">
            <ShieldCheckIcon className="w-10 h-10 text-gold shrink-0" data-id="element-153" />
            <div className="text-left" data-id="element-154">
              <h4 className="font-bold text-offwhite uppercase tracking-wide text-sm" data-id="element-155">
                7-Day Money-Back Guarantee
              </h4>
              <p className="text-xs text-muted mt-1" data-id="element-156">
                If you're not satisfied within 7 days, we'll refund your
                purchase. No questions asked.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm text-muted" data-id="element-157">
            <div className="flex items-center gap-2" data-id="element-158">
              <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-159" />
              <span data-id="element-160">Secure checkout</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-161">
              <ZapIcon className="w-4 h-4 text-gold" data-id="element-162" />
              <span data-id="element-163">Digital delivery</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}